import React from "react";
import {
    Box,
    Container,
    Typography,
    Grid,
    Card,
    CardContent,
    Button,
    Stack,
} from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useLanguage } from "../../context/LanguageContext";
import XmLicense from "./XmLicense";

const Regulations = () => {
    const { language, translations } = useLanguage();




    return (
        <>
            <Box
                // mt={12}
                textAlign="center"
                // mb={6}
                pt={{ xs: 13, sm: 19, md: 22 }}
                pb={14}
                px={{ xs: 3, sm: 5, md: 9 }}
                sx={{
                    background: "linear-gradient(to bottom, #f5f6fa 0%, #f5f6fa 40%)",
                }}
            >
                <Typography variant="h2" fontWeight="bold" gutterBottom>
                    Regulations
                </Typography>
                <Typography
                    maxWidth={{ xs: "1250", sm: "1560px", md: "1560px" }}
                    mx="auto"
                    mb={3}
                    style={{
                        color: "#000000B2",
                        fontSize: "22px",
                        color: "#212529c4",
                        fontWeight: "400",
                        fontFamily: "SF Pro Display",
                        padding: "0px 15px 0px 15px",
                    }}
                >
                    We are authorised and regulated by reputable regulatory authorities, providing you with confidence when trading with us.


                </Typography>

            </Box>

            <XmLicense />

        </>
    );
};

export default Regulations;
